

import React, { useEffect, useState } from 'react';
import API from '../../services/api';
import CookieManager from "../../services/CookieManager";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

export default function LicenseBar() {
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const [chartOptions, setChartOptions] = useState({});
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().setMonth(new Date().getMonth() - 6)),
    endDate: new Date()
  });
  const [loading, setLoading] = useState(false);
  const [staffIds, setStaffIds] = useState([]);

  const profileData = CookieManager.getCookie("user-data")?.length ? JSON.parse(CookieManager.getCookie("user-data")) : null;
  const userType = profileData?.userType;

  // Fetch staff users for admin/corporate
  useEffect(() => {

        /* let query=[
         {
           '$project': {
             'lable': 'count', 
             'downloadedTracks': {
               '$sum': {
                 '$size': '$downloadedTracks'
               }
             }
           }
         }, {
           '$group': {
             '_id': '$lable', 
             'total': {
               '$sum': '$downloadedTracks'
             }
           }
         }
       ]*/
    if (userType === "SUPER_ADMIN") return;
    let filter = { userType: "CORPORATE" };
    filter["admin"] = profileData.email;
    API.getUserList({ filter }).then(res => {
      if (res.success) {
        setStaffIds(res.data.map(staff => staff._id));
      } else {
        setStaffIds([]);
      }
    });
    // eslint-disable-next-line
  }, []);

  // Fetch chart data on staffIds or dateRange change
  useEffect(() => {
    if (userType === "SUPER_ADMIN") {
      let query = [
        {
          '$project': {
            'month': { '$month': '$createdAt' },
            'year': { '$year': '$createdAt' }
          }
        }, {
          '$group': {
            '_id': { 'month': '$month', 'year': '$year' },
            'total': { '$sum': 1 },
            'month': { '$first': '$month' },
            'year': { '$first': '$year' }
          }
        }, {
          '$match': { 'year': new Date().getFullYear() }
        }
      ];
      API.getLicAggregate(query).then(res => {
        if (res.success) {
          prepareChart(res.data);
        }
      });
    } else if (staffIds.length > 0) {
      setLoading(true);
      let filter = {
        licensee: { '$in': staffIds },
        "$or": [
          { "$and": [ { createdAt: { "$gte": dateRange.startDate } }, { createdAt: { "$lte": dateRange.endDate } } ] },
          { "$and": [ { updatedAt: { "$gte": dateRange.startDate } }, { updatedAt: { "$lte": dateRange.endDate } } ] }
        ]
      };
      API.getLicenses({ query: filter }).then(resp => {
        setLoading(false);
        if (resp.success) {
          prepareChartFromLicenses(resp.data);
        } else {
          setChartOptions({});
        }
      });
    } else {
      setChartOptions({});
    }
    // eslint-disable-next-line
  }, [staffIds, dateRange]);

  const prepareChart = (data) => {
    if (!data || !data.length) return setChartOptions({});
    data = data.sort((a, b) => a.month - b.month);
    let xaxis = monthNames.slice(0, data[data.length - 1].month);
    let ydata = [];
    let i = 1;
    while (i <= data[data.length - 1].month) {
      let filtermonth = data.filter(item => item.month === i);
      ydata[i - 1] = filtermonth.length ? filtermonth[0].total : 0;
      i++;
    }
    setChartOptions({
      chart: { height: "350px" },
      title: { text: "Number of Licenses generated" },
      plotOptions: { line: { dataLabels: { enabled: true }, enableMouseTracking: false } },
      xAxis: { categories: xaxis },
      yAxis: { title: { text: 'No. of License generated' } },
      series: [{ name: 'Month', data: ydata, type: 'column' }]
    });
  };

  const prepareChartFromLicenses = (licenses) => {
    if (!licenses || !licenses.length) return setChartOptions({});
    let grouped = {};
    licenses.forEach(lic => {
      let date = new Date(lic.createdAt);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let key = `${year}-${month}`;
      if (!grouped[key]) grouped[key] = 0;
      grouped[key]++;
    });
    let keys = Object.keys(grouped).sort();
    let xaxis = keys.map(k => {
      let [year, month] = k.split('-');
      return `${monthNames[parseInt(month) - 1]} ${year}`;
    });
    let ydata = keys.map(k => grouped[k]);
    setChartOptions({
      chart: { height: "350px" },
      title: { text: "Number of Licenses generated" },
      plotOptions: { line: { dataLabels: { enabled: true }, enableMouseTracking: false } },
      xAxis: { categories: xaxis },
      yAxis: { title: { text: 'No. of License generated' } },
      series: [{ name: 'Month', data: ydata, type: 'column' }]
    });
  };

  // Date range picker UI for admin/corporate
  const renderDateRangePicker = () => {
    if (userType === "SUPER_ADMIN") return null;
    return (
      <div className="flex gap-4 mb-4">
        <div>
          <label>From:</label>
          <input type="date" value={dateRange.startDate.toISOString().slice(0, 10)} onChange={e => setDateRange({ ...dateRange, startDate: new Date(e.target.value) })} />
        </div>
        <div>
          <label>To:</label>
          <input type="date" value={dateRange.endDate.toISOString().slice(0, 10)} onChange={e => setDateRange({ ...dateRange, endDate: new Date(e.target.value) })} />
        </div>
      </div>
    );
  };

  return (
    <div>
      {renderDateRangePicker()}
      {loading ? <div>Loading...</div> : <HighchartsReact highcharts={Highcharts} options={chartOptions} />}
    </div>
  );
}
